import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Form, Grid, Row, Col } from 'react-bootstrap/lib';
import CodeTextArea from '../inputs/CodeTextArea';
import { widgetsScriptURL } from '../../../util/constants';

class APIEditor extends PureComponent {
  render() {
    const {
      dealer,
      page: { title },
    } = this.props;

    return (
      <Form>
        <Grid fluid>
          <Row>
            <Col sm={12}>
              <h3>{title}</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h4>Markup</h4>
              <small>
                Copy the markup below into your page template. Only add this
                script once per page.
              </small>
              <CodeTextArea
                label="Agent Script"
                value={`<!— COPY this markup into your page template after the closing <body/> tag —>\n<script src="${widgetsScriptURL}" type="text/javascript" id="prodigyButtonGroupAgent" dealerId="${dealer?.id}"></script>`}
              />

              <h4>
                Copy this following attributes onto any element in order to
                launch Upstart Online
              </h4>

              <CodeTextArea
                label="Browse"
                value={`onClick="Prodigy.openFrame('browse')" data-config-type="API"`}
              />

              <CodeTextArea
                label="Trade-In"
                value={`onClick="Prodigy.openFrame('trade-in')" data-config-type="API"`}
              />

              <CodeTextArea
                label="Credit Application"
                value={`onClick="Prodigy.openFrame('pre-approval')" data-config-type="API"`}
              />
            </Col>
          </Row>
        </Grid>
      </Form>
    );
  }
}

APIEditor.propTypes = {
  page: PropTypes.object,
  formData: PropTypes.object,
  onChange: PropTypes.func,
  dealer: PropTypes.object,
};

export default APIEditor;
